import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useIntl } from "react-intl";

import StateIcon from "../../app/generic/stateIcon";
import TableHeader from "../../app/generic/tableHeader";
import ProductSelect from "../productChoice/productSelect";

import "./index.css";

const ConsignmentHeader = ({
  edit,
  detail,
  product,
  templateName,
  productGroups,
  onProductSelect,
}) => {
  const intl = useIntl();
  const { pathname } = useLocation();
  const [title, setTitle] = useState();
  useEffect(() => {
    setTitle(
      pathname.endsWith("template")
        ? intl.formatMessage({
            id: "consignment.template.new",
            defaultMessage: "Nová šablona",
          })
        : templateName
        ? intl.formatMessage({
            id: "consignment.template.edit",
            defaultMessage: "Editace šablony",
          })
        : detail
        ? intl.formatMessage({
            id: "consignment.detail",
            defaultMessage: "Detail zásilky",
          })
        : pathname.endsWith("edit")
        ? intl.formatMessage({
            id: "consignment.edit",
            defaultMessage: "Editace zásilky",
          })
        : intl.formatMessage({
            id: "consignment.new",
            defaultMessage: "Nová zásilka",
          })
    );
  }, [intl, pathname, detail, templateName]);

  const [selectComponent, setSelectComponent] = useState(null);
  useEffect(() => {
    if (productGroups && productGroups !== "e") {
      setSelectComponent(
        product ? (
          <ProductSelect
            selectedProduct={product}
            productGroups={productGroups}
            onProductSelect={onProductSelect}
          />
        ) : null
      );
    } else if (productGroups === "e") {
      setSelectComponent(
        <StateIcon
          valid={false}
          messages={[
            intl.formatMessage({
              id: "consignment.product.cannotLoad",
              defaultMessage: "Nepodařilo se načíst dostupné produkty.",
            }),
          ]}
        />
      );
    }
  }, [intl, edit, product, productGroups, onProductSelect]);

  return (
    <TableHeader
      equal
      title={title}
      titleClass="consignment-header-title"
      left={selectComponent}
    />
  );
};

export default ConsignmentHeader;
